"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TGScatterPlotChart = void 0;
const react_1 = __importStar(require("react"));
const scatterplot_1 = require("@nivo/scatterplot");
const lodash_1 = require("lodash");
const moment_1 = __importDefault(require("moment"));
const gen5_shared_utilities_1 = require("@terragotech/gen5-shared-utilities");
const configContext_1 = require("../../../contexts/configContext");
const common_1 = require("./common");
const TGScatterPlotChart = (props) => {
    // TODO: [S5-3587] Consolidate inline props with `defaultProps` to facilitate options/value property merging with default values.
    const chartProps = (0, react_1.useMemo)(() => (0, common_1.mergeChartProps)(props, SAMPLE_PROPS), [props]);
    const { data, legendPosition, colorPalette: colorPaletteName } = chartProps;
    const { colorPalettes, defaultDateTimeFormat, primaryPalette } = (0, configContext_1.useConfig)();
    const colors = (0, react_1.useMemo)(() => { var _a, _b, _c; return (_c = (_b = (_a = colorPalettes === null || colorPalettes === void 0 ? void 0 : colorPalettes.find(x => x.name === colorPaletteName)) === null || _a === void 0 ? void 0 : _a.colors) !== null && _b !== void 0 ? _b : primaryPalette) !== null && _c !== void 0 ? _c : undefined; }, [colorPalettes, colorPaletteName]);
    const { dateFormat, dateTimeFormat } = (0, react_1.useMemo)(() => ({
        dateFormat: (0, gen5_shared_utilities_1.getDateFormat)(defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateFormatType, defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateFormat, defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateSeperator, { datePartOnly: true, tokenConversion: gen5_shared_utilities_1.DATETIME_TOKEN_CONVERSION.MomentJS }),
        dateTimeFormat: (0, gen5_shared_utilities_1.getDateTimeFormat)(defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateFormatType, defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateFormat, defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateSeperator, defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.timeFormat, { tokenConversion: gen5_shared_utilities_1.DATETIME_TOKEN_CONVERSION.MomentJS }),
    }), [defaultDateTimeFormat]);
    const { isXAxisDate, isYAxisDate } = (0, react_1.useMemo)(() => data.reduce((acc, serie) => {
        var _a, _b;
        return ({
            isXAxisDate: acc.isXAxisDate || ((_a = serie.data) === null || _a === void 0 ? void 0 : _a.some(d => (0, lodash_1.isDate)(d.x))),
            isYAxisDate: acc.isYAxisDate || ((_b = serie.data) === null || _b === void 0 ? void 0 : _b.some(d => (0, lodash_1.isDate)(d.y))),
        });
    }, { isXAxisDate: false, isYAxisDate: false }), [data]);
    const formatDateValue = (value) => {
        const local = (0, moment_1.default)(value);
        return local.millisecond() === 0 ? moment_1.default.utc(value).format(dateFormat) : local.format(dateTimeFormat);
    };
    // TODO: [S5-3587] Should we instead filter and show what we can?
    const hasMissingSerieData = (0, react_1.useMemo)(() => data.reduce((prev, curr) => {
        var _a;
        return prev || !((_a = curr.data) === null || _a === void 0 ? void 0 : _a.length);
    }, false), [data]);
    if (hasMissingSerieData) {
        return react_1.default.createElement("div", null, "No results");
    }
    return (react_1.default.createElement(scatterplot_1.ResponsiveScatterPlot, Object.assign({ colors: colors, margin: Object.assign({ top: 50, left: 60 }, (legendPosition === 'bottom'
            ? {
                right: 60,
                bottom: 80,
            }
            : {
                right: 140,
                bottom: 70,
            })), xScale: {
            type: isXAxisDate ? 'time' : 'linear',
            nice: true,
            min: 'auto',
            max: 'auto',
        }, xFormat: isXAxisDate ? formatDateValue : '>-.2f', yScale: {
            type: isYAxisDate ? 'time' : 'linear',
            nice: true,
            min: 'auto',
            max: 'auto',
        }, yFormat: isYAxisDate ? formatDateValue : '>-.2f', blendMode: "multiply", axisTop: null, axisRight: null, axisBottom: {
            tickSize: 5,
            tickPadding: 5,
            tickRotation: -20,
            truncateTickAt: 0,
            format: isXAxisDate ? formatDateValue : undefined,
        }, axisLeft: {
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            truncateTickAt: 0,
            format: isYAxisDate ? formatDateValue : undefined,
        }, legends: [
            Object.assign(Object.assign({}, (legendPosition === 'bottom'
                ? {
                    anchor: 'bottom',
                    direction: 'row',
                    translateX: 0,
                    translateY: 56,
                }
                : {
                    anchor: 'bottom-right',
                    direction: 'column',
                    translateX: 130,
                    translateY: 0,
                })), { justify: false, itemWidth: 100, itemHeight: 12, itemsSpacing: 5, itemDirection: 'left-to-right', symbolSize: 12, symbolShape: 'circle', effects: [
                    {
                        on: 'hover',
                        style: {
                            itemOpacity: 1,
                        },
                    },
                ] }),
        ] }, chartProps)));
};
exports.TGScatterPlotChart = TGScatterPlotChart;
const SAMPLE_PROPS = {
    data: [
        {
            id: 'Group A',
            data: [
                { x: 33, y: 45 },
                { x: 37, y: 11 },
                { x: 91, y: 105 },
                { x: 60, y: 103 },
                { x: 47, y: 72 },
                { x: 30, y: 26 },
                { x: 2, y: 52 },
                { x: 23, y: 53 },
                { x: 31, y: 61 },
                { x: 21, y: 56 },
                { x: 70, y: 92 },
                { x: 71, y: 119 },
                { x: 86, y: 82 },
                { x: 8, y: 115 },
                { x: 19, y: 39 },
                { x: 38, y: 68 },
                { x: 13, y: 76 },
                { x: 83, y: 117 },
                { x: 74, y: 35 },
                { x: 59, y: 100 },
                { x: 88, y: 120 },
                { x: 1, y: 17 },
                { x: 53, y: 3 },
                { x: 92, y: 40 },
                { x: 76, y: 111 },
                { x: 68, y: 107 },
                { x: 51, y: 120 },
                { x: 21, y: 46 },
                { x: 42, y: 86 },
                { x: 78, y: 30 },
                { x: 76, y: 5 },
                { x: 93, y: 117 },
                { x: 44, y: 92 },
                { x: 63, y: 22 },
                { x: 34, y: 85 },
                { x: 43, y: 77 },
                { x: 26, y: 80 },
                { x: 30, y: 91 },
                { x: 9, y: 86 },
                { x: 94, y: 106 },
                { x: 89, y: 30 },
                { x: 62, y: 24 },
                { x: 33, y: 66 },
                { x: 68, y: 46 },
                { x: 8, y: 12 },
                { x: 18, y: 120 },
                { x: 11, y: 33 },
                { x: 26, y: 33 },
                { x: 63, y: 44 },
                { x: 71, y: 60 },
            ],
        },
        {
            id: 'Group B',
            data: [
                { x: 25, y: 57 },
                { x: 27, y: 85 },
                { x: 97, y: 42 },
                { x: 82, y: 69 },
                { x: 51, y: 60 },
                { x: 68, y: 9 },
                { x: 62, y: 23 },
                { x: 54, y: 43 },
                { x: 87, y: 102 },
                { x: 18, y: 1 },
                { x: 78, y: 0 },
                { x: 18, y: 92 },
                { x: 55, y: 21 },
                { x: 52, y: 117 },
                { x: 55, y: 96 },
                { x: 53, y: 88 },
                { x: 51, y: 35 },
                { x: 48, y: 47 },
                { x: 73, y: 28 },
                { x: 53, y: 65 },
                { x: 56, y: 106 },
                { x: 49, y: 59 },
                { x: 87, y: 34 },
                { x: 43, y: 75 },
                { x: 75, y: 93 },
                { x: 74, y: 13 },
                { x: 70, y: 32 },
                { x: 6, y: 21 },
                { x: 56, y: 119 },
                { x: 98, y: 43 },
                { x: 32, y: 119 },
                { x: 91, y: 74 },
                { x: 68, y: 60 },
                { x: 18, y: 20 },
                { x: 15, y: 45 },
                { x: 3, y: 59 },
                { x: 22, y: 35 },
                { x: 6, y: 81 },
                { x: 17, y: 116 },
                { x: 39, y: 119 },
                { x: 53, y: 87 },
                { x: 28, y: 77 },
                { x: 4, y: 70 },
                { x: 3, y: 93 },
                { x: 54, y: 109 },
                { x: 67, y: 118 },
                { x: 16, y: 114 },
                { x: 84, y: 89 },
                { x: 73, y: 49 },
                { x: 42, y: 38 },
            ],
        },
        {
            id: 'Group C',
            data: [
                { x: 26, y: 37 },
                { x: 11, y: 86 },
                { x: 96, y: 120 },
                { x: 18, y: 111 },
                { x: 57, y: 106 },
                { x: 74, y: 89 },
                { x: 20, y: 84 },
                { x: 93, y: 69 },
                { x: 73, y: 65 },
                { x: 71, y: 116 },
                { x: 29, y: 38 },
                { x: 37, y: 78 },
                { x: 9, y: 98 },
                { x: 37, y: 78 },
                { x: 99, y: 77 },
                { x: 97, y: 16 },
                { x: 24, y: 116 },
                { x: 98, y: 32 },
                { x: 85, y: 119 },
                { x: 26, y: 13 },
                { x: 78, y: 59 },
                { x: 73, y: 116 },
                { x: 24, y: 32 },
                { x: 81, y: 36 },
                { x: 83, y: 50 },
                { x: 84, y: 71 },
                { x: 27, y: 55 },
                { x: 65, y: 30 },
                { x: 21, y: 61 },
                { x: 11, y: 78 },
                { x: 8, y: 96 },
                { x: 58, y: 55 },
                { x: 81, y: 96 },
                { x: 98, y: 9 },
                { x: 63, y: 21 },
                { x: 37, y: 41 },
                { x: 56, y: 53 },
                { x: 27, y: 73 },
                { x: 69, y: 26 },
                { x: 80, y: 22 },
                { x: 42, y: 36 },
                { x: 37, y: 120 },
                { x: 56, y: 108 },
                { x: 46, y: 36 },
                { x: 37, y: 51 },
                { x: 64, y: 67 },
                { x: 38, y: 114 },
                { x: 65, y: 97 },
                { x: 26, y: 54 },
                { x: 23, y: 79 },
            ],
        },
        {
            id: 'Group D',
            data: [
                { x: 93, y: 82 },
                { x: 50, y: 50 },
                { x: 41, y: 11 },
                { x: 42, y: 73 },
                { x: 28, y: 13 },
                { x: 77, y: 74 },
                { x: 1, y: 7 },
                { x: 3, y: 33 },
                { x: 80, y: 119 },
                { x: 69, y: 67 },
                { x: 96, y: 91 },
                { x: 27, y: 22 },
                { x: 82, y: 98 },
                { x: 60, y: 3 },
                { x: 32, y: 119 },
                { x: 17, y: 101 },
                { x: 83, y: 73 },
                { x: 46, y: 115 },
                { x: 11, y: 10 },
                { x: 27, y: 76 },
                { x: 5, y: 120 },
                { x: 15, y: 112 },
                { x: 60, y: 12 },
                { x: 62, y: 19 },
                { x: 72, y: 93 },
                { x: 25, y: 120 },
                { x: 19, y: 97 },
                { x: 60, y: 58 },
                { x: 21, y: 64 },
                { x: 92, y: 107 },
                { x: 20, y: 46 },
                { x: 64, y: 9 },
                { x: 52, y: 24 },
                { x: 20, y: 95 },
                { x: 74, y: 60 },
                { x: 47, y: 77 },
                { x: 14, y: 71 },
                { x: 39, y: 117 },
                { x: 68, y: 93 },
                { x: 62, y: 32 },
                { x: 20, y: 53 },
                { x: 71, y: 43 },
                { x: 82, y: 57 },
                { x: 98, y: 103 },
                { x: 8, y: 61 },
                { x: 8, y: 50 },
                { x: 43, y: 46 },
                { x: 24, y: 38 },
                { x: 91, y: 44 },
                { x: 15, y: 120 },
            ],
        },
        {
            id: 'Group E',
            data: [
                { x: 5, y: 105 },
                { x: 54, y: 114 },
                { x: 89, y: 91 },
                { x: 71, y: 53 },
                { x: 94, y: 1 },
                { x: 2, y: 117 },
                { x: 48, y: 0 },
                { x: 82, y: 44 },
                { x: 18, y: 101 },
                { x: 99, y: 97 },
                { x: 68, y: 66 },
                { x: 46, y: 62 },
                { x: 46, y: 73 },
                { x: 98, y: 88 },
                { x: 16, y: 101 },
                { x: 47, y: 81 },
                { x: 12, y: 57 },
                { x: 28, y: 42 },
                { x: 28, y: 36 },
                { x: 63, y: 8 },
                { x: 20, y: 115 },
                { x: 68, y: 96 },
                { x: 23, y: 87 },
                { x: 37, y: 43 },
                { x: 7, y: 100 },
                { x: 1, y: 4 },
                { x: 58, y: 82 },
                { x: 62, y: 18 },
                { x: 37, y: 40 },
                { x: 20, y: 53 },
                { x: 44, y: 120 },
                { x: 54, y: 118 },
                { x: 34, y: 46 },
                { x: 86, y: 3 },
                { x: 50, y: 94 },
                { x: 12, y: 98 },
                { x: 51, y: 35 },
                { x: 86, y: 35 },
                { x: 76, y: 92 },
                { x: 24, y: 26 },
                { x: 24, y: 38 },
                { x: 50, y: 82 },
                { x: 5, y: 71 },
                { x: 20, y: 38 },
                { x: 10, y: 104 },
                { x: 77, y: 42 },
                { x: 2, y: 91 },
                { x: 48, y: 10 },
                { x: 81, y: 50 },
                { x: 82, y: 74 },
            ],
        },
    ],
};
exports.default = exports.TGScatterPlotChart;
//# sourceMappingURL=TGScatterPlotChart.js.map